import { Paragraph } from "@sentara-health/optimahealth_web";
import { formatPersonName } from "utils/helpers/TextFormaters";
import { ProfileRegex } from "../../utils/constants/Regex";
import { useBranding, Brands } from "providers";

/* first letter interface */
interface FirstLetter {
  firstName: string;
  lastName: string;
}

export const ProfileFirstLetter = ({
  firstName = "",
  lastName = "",
}: FirstLetter) => {
  /* Detemine user first letter */
  const getUserFirstLetter = () => {
    const name = `${firstName} ${lastName}`;
    const matches = name.match(ProfileRegex);
    return matches?.join("") || "";
  };
  const { brandConfig: brandingConfig } = useBranding();

  return (
    <>
      {brandingConfig.brandName !== Brands.AVMED ? (
        <div
          data-testid="profileCardInitials"
          className="d-flex rounded-circle mx-auto justify-content-center align-items-center profile-image-small profile-name-text"
        >
          {getUserFirstLetter()}
        </div>
      ) : (
        <Paragraph
          className="d-flex rounded-circle mx-auto justify-content-center align-items-center profile-image-small profile-name-text"
          level={4}
          text={getUserFirstLetter()}
          variant={"bold"}
          data-testid="profileCardInitials"
        />
      )}
    </>
  );
};
